"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTeam = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const Team_1 = require("./Team");
const irlcg_1 = require("../ontologies/irlcg");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
let EventTeam = class EventTeam extends Team_1.Team {
    get startDate() {
        return XSDDate_1.XSDDate.toNativeDate(this.getOne(irlcg_1.irlcg.startDate));
    }
    set startDate(val) {
        val
            ? this.overwrite(irlcg_1.irlcg.startDate, XSDDate_1.XSDDate.fromNativeDate(val).node)
            : this.unsetAll(irlcg_1.irlcg.startDate);
    }
    get endDate() {
        return XSDDate_1.XSDDate.toNativeDate(this.getOne(irlcg_1.irlcg.endDate));
    }
    set endDate(val) {
        val
            ? this.overwrite(irlcg_1.irlcg.endDate, XSDDate_1.XSDDate.fromNativeDate(val).node)
            : this.unsetAll(irlcg_1.irlcg.endDate);
    }
    get attendance() {
        return this.getValue(irlcg_1.irlcg.attendance);
    }
    set givenName(val) {
        this.overwrite(irlcg_1.irlcg.attendance, new models_1.Literal(val));
    }
    static getUserEventTeams(user) {
        return Server_1.Server.call(this, 'getUserEventTeams', user);
    }
    static getEventTeamById(teamId) {
        return Server_1.Server.call(this, 'getEventTeamById', teamId);
    }
    static createEventTeam(name, description, startDate, endDate, image) {
        return Server_1.Server.call(this, 'createEventTeam', name, description, startDate, endDate, image);
    }
    static getAllEventTeams() {
        return Server_1.Server.call(this, 'getAllEventTeams');
    }
};
exports.EventTeam = EventTeam;
EventTeam.targetClass = irlcg_1.irlcg.EventTeam;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.startDate,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], EventTeam.prototype, "startDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.endDate,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], EventTeam.prototype, "endDate", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.attendance,
        // required: true,
        dataType: xsd_1.xsd.string,
        maxCount: 1,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventTeam.prototype, "attendance", null);
exports.EventTeam = EventTeam = __decorate([
    package_1.linkedShape
], EventTeam);
//# sourceMappingURL=EventTeam.js.map